export const getPickUpLocationAddress = (trip) => {
    return {
        desc: {
            description: trip.pickUpLocation.address
        },
        location: {
            address: trip.pickUpLocation.address,
            desc: {
                description: trip.pickUpLocation.address
            },
            lat: trip.pickUpLocation.lat,
            lng: trip.pickUpLocation.lon
        }
    }
}

export const getDropOffLocationAddress = (trip) => {
    return {
        desc: {
            description: trip.dropOffLocation.address
        },
        location: {
            address: trip.dropOffLocation.address,
            desc: {
                description: trip.dropOffLocation.address
            },
            lat: trip.dropOffLocation.lat,
            lng: trip.dropOffLocation.lon
        }
    }
}

export function getLatitude(point) {
    return point.latitude || point.lat;
}

export function getLongitude(point) {
    return point.longitude || point.lng || point.lon;
}

export function filterTime(date) {
    const isPastTime = new Date().getTime() > date.getTime()
    return !isPastTime
}